// extracted by mini-css-extract-plugin
export default {"wrapper":"Average_wrapper__XjJoJ","badge":"Average_badge__gmdk7","light":"Average_light__1DLRz"};